import CouponApi from '@apis/coupon/CouponApi';
import couponQueries from '@apis/queries/couponQueries';
import {
    GetDownloadableCouponsParams,
} from '@models/coupon';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getIsBlank, getNextPageParam } from '@utils/slice';
import { useAtomValue } from 'jotai';

import { couponSortsAtom } from '../../../atoms/couponAtoms';

function useDownloadAbleCoupons() {
    const sort = useAtomValue(couponSortsAtom).DOWNLOAD;
    const params: Omit<GetDownloadableCouponsParams, 'page'> = {
        size: 20,
        sorter: sort === 'closingSoon' ? 'EndAtAsc' : 'CreatedAtAsc',
    };
    const queryInfo = useInfiniteQuery({
        queryKey: couponQueries.downloadAble(params).queryKey,
        queryFn: ({ pageParam }) => CouponApi.getDownloadableCoupons({
            ...params, page: pageParam,
        }),
        initialPageParam: 0,
        getNextPageParam,
    });
    const coupons = getFlattenPageResponse(queryInfo);
    const isBlank = getIsBlank(queryInfo);
    return {
        ...queryInfo,
        isBlank,
        coupons,
    };
}

export default useDownloadAbleCoupons;
